import { render, staticRenderFns } from "./FormSearchBox.vue?vue&type=template&id=520d8660&"
import script from "./FormSearchBox.vue?vue&type=script&lang=js&"
export * from "./FormSearchBox.vue?vue&type=script&lang=js&"
import style0 from "./FormSearchBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports